var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-3" },
    [
      _c(
        "v-btn-toggle",
        { attrs: { dense: "" } },
        _vm._l(_vm.navItems, function(item) {
          return _c(
            "v-btn",
            { key: item.title, attrs: { to: { name: item.to }, exact: "" } },
            [
              _c("span", { staticClass: "hidden-sm-and-down" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _c("v-icon", { staticClass: "ml-md-2" }, [
                _vm._v(" " + _vm._s(item.icon) + " ")
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }